import {
    SET_TOKEN
} from '../actions/actionTypes';

const initialState = {};


function authReducer(state = initialState, action) {
  switch (action.type) {
    case SET_TOKEN:
      return action.payload;
    
    default:
      return state;
  }
}

export default authReducer;